export default "__VITE_ASSET__DHxpqey$__"